import { useCallback } from 'react';
import { useAppSelector } from '@/store/hooks';
import { collectionsSelector } from '@/store/selectors/collections';
import { useActiveUser } from '@/platform-services/auth';
export const useFindAreasForCollection = () => {
    const collections = useAppSelector(collectionsSelector);
    const activeUser = useActiveUser();
    return useCallback((collectionName, areas) => {
        const foundCollection = collections.find((collection) => (collection === null || collection === void 0 ? void 0 : collection.collection) === collectionName);
        if (!(areas === null || areas === void 0 ? void 0 : areas.length) || !foundCollection || !activeUser) {
            return [];
        }
        return areas.filter(({ id, collectionId }) => activeUser.areaPermissions
            .some(({ areaId }) => areaId === id) && collectionId === (foundCollection === null || foundCollection === void 0 ? void 0 : foundCollection.id))
            .sort((lhs, rhs) => lhs.name.localeCompare(rhs.name));
    }, [collections, activeUser]);
};
